import { comments } from '@/mocks/home';

const avatarImages: Record<string, string> = {
  'avatar-1': 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20soft%20smile%2C%20warm%20brown%20hair%2C%20simple%20light%20background%2C%20clean%20illustration%20style%2C%20friendly%20expression&width=120&height=120&seq=avatar-1&orientation=squarish',
  'avatar-2': 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20portrait%2C%20dark%20hair%2C%20calm%20expression%2C%20simple%20light%20background%2C%20clean%20illustration%20style%2C%20thoughtful%20look&width=120&height=120&seq=avatar-2&orientation=squarish',
  'avatar-3': 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20portrait%2C%20short%20hair%2C%20bright%20eyes%2C%20simple%20light%20background%2C%20clean%20illustration%20style%2C%20cheerful%20expression&width=120&height=120&seq=avatar-3&orientation=squarish',
};

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">读者评论</h2>
          <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">真实用户反馈</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div key={comment.id} className="p-5 rounded-lg bg-background-100 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={avatarImages[comment.avatarSeq]}
                    alt={`读者 ${comment.name}`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800 truncate">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>

              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                ))}
              </div>

              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}